import { useEffect, useRef } from 'react';
import trainingHtml from './gwi360-training-v11.html?raw';

function DriverManagementTraining() {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const blob = new Blob([trainingHtml], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    if (iframeRef.current) {
      iframeRef.current.src = url;
    }
    return () => URL.revokeObjectURL(url);
  }, []);

  return (
    <iframe
      ref={iframeRef}
      title="Driver Management Training"
      style={{ width: '100%', height: '100%', border: 'none' }}
    />
  );
}

export default DriverManagementTraining;
